import { createReducer, on } from '@ngrx/store';
import {
  getAllQueries,
  saveQBQueries,
  setAllQueries,
  setQBFields,
  setQBProperties,
  setQBQueries
} from '../actions/queryBuilder.actions';

export interface QueryBuilderState {}

export const initialState: QueryBuilderState = {};

export const queryBuilderReducer = createReducer(
  initialState,
  on(setQBFields, (state, { qbFields }) => ({
    ...state,
    ...{ qbFields }
  })),
  on(setQBQueries, (state, { qbQueries }) => ({
    ...state,
    ...{ qbQueries }
  })),
  on(saveQBQueries, (state, { queryObject }) => ({
    ...state,
    ...{ queryObject }
  })),
  on(setAllQueries, (state, { allQueries }) => ({
    ...state,
    ...{ allQueries }
  })),
  on(setQBProperties, (state, { qbProperties }) => {
    return {
      ...state,
      qbProperties
    };
  })
);
